require("./accountDirectDebitStep3.scss");

//@vendors
const React = require('react');
const PropTypes = require('prop-types');

//@helper
const { formatText, FormattedText } = require('core/i18n').i18n;

//@commons
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');

//@components
const UploadedDocumentRow = require('./uploadedDocumentRow/uploadedDocumentRow');
const { ContractDisclaimerPersonalInfo } = require('routes/contractsView/components/ContractDisclaimerPersonalInfo/ContractDisclaimerPersonalInfo');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

//@constants
const {
    FILE_NUMBER_LIMIT,
    FILE_SIZE_LIMIT,
    FILE_TYPES,
    FILE_NAME_CHARS_LIMIT,
    FILE_NAME_REGEX
} = require('constants/accountDirectDebit');
const {
    VALID_TYPES_FILE
} = require('constants/fileRequirements');
const ALTERED_FILE_TYPES = FILE_TYPES.map((type) => {
    let file_type = type;
    if(type.toLowerCase() === VALID_TYPES_FILE.JPEG) {
        file_type = VALID_TYPES_FILE.JPG
    }
    return file_type;
});

const texts = {
    sizeError: <FormattedText value="accountDirectDebitStep3-fileUploadSizeError" injectedStrings={[FILE_SIZE_LIMIT/1000]} />,
    typeError: <FormattedText value="accountDirectDebitStep3-fileUploadTypeError" injectedStrings={[ALTERED_FILE_TYPES.join(', ').toUpperCase()]} />,
    maxLengthError: <FormattedText value="accountDirectDebitStep3-fileUploadNameLengthError" injectedStrings={[FILE_NAME_CHARS_LIMIT]} />,
    whiteListError: <FormattedText value="accountDirectDebitStep3-fileUploadNameFormatError"/>,
    duplicateFileNameError: <FormattedText value="accountDirectDebitStep3-fileUploadDuplicateNameError"/>
}

class AccountDirectDebitStep3  extends React.Component {
    constructor(props){
        super(props);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleOnChange(fileState) {
        this.props.addFile(fileState);
    }

    createUpload() {
        const { immStep } = this.props;
        const filesAttached = immStep.get('filesAttached');
        let fileNameList = [];
        filesAttached.forEach((file) => {
            fileNameList.push(file.get('name'));
        });

        if(filesAttached.size < FILE_NUMBER_LIMIT) {
            return(
                <div className="row">
                    <div className="account-direct-debit-step3__upload-section col-xs-6">
                        <DragNDropUpload
                            attachedFileList={fileNameList}
                            checkDuplicateFileName={true}
                            errorIconClass="icon-error account-direct-debit-step3__icon account-direct-debit-step3__icon--error"
                            errorMessage=""
                            fileText=""
                            hideFormats={true}
                            hideShowAttachLink={true}
                            hideSizeLimit={true}
                            hideSuccessState={true}
                            hideUploadedFileList={true}
                            iconClass="icon-subir account-direct-debit-step3__icon"
                            idName=""
                            isModern={true}
                            isTrashVisible={true}
                            maxLengthFileName={FILE_NAME_CHARS_LIMIT}
                            maxSize={FILE_SIZE_LIMIT}
                            onChange={this.handleOnChange}
                            overwriteFile={true}
                            textDescription={formatText('accountDirectDebitStep3-dropBoxLabel')}
                            textLinkDescription={formatText('accountDirectDebitStep3-dropBoxLink')}
                            texts={texts}
                            title=""
                            validTypesFile={FILE_TYPES}
                            whiteListFileNameCharsRegExp={FILE_NAME_REGEX}
                        />
                    </div>
                </div>
            );
        }
    }

    render(){
        const { immStep, removeFile, setDescription } = this.props;
        const filesAttached = immStep.get('filesAttached');
        let uploadHeadings;
        if(filesAttached.size > 0) {
            uploadHeadings = (
                <p className="account-direct-debit-step3__uploaded-text row">
                    <FormattedText
                        value="accountDirectDebitStep3-attachCountText"
                        className="col-xs-6"
                        injectedStrings={[filesAttached.size,FILE_NUMBER_LIMIT]}
                    />
                    <div className="col-xs-6">
                        <FormattedText
                            value="accountDirectDebitStep3-commentText"
                        />
                        <OKTooltip
                            content="accountDirectDebitStep3-descriptionTooltip"
                            placement="bottom"
                            offset={[0, 15]}
                        />
                    </div>
                </p>
            );
        }else {
            uploadHeadings = (
                <FormattedText
                    value="accountDirectDebitStep3-noFilesText"
                    className="account-direct-debit-step3__no-files-text"
                />
            );
        }

        return(
            <div className="account-direct-debit-step3">
                <h2 className="account-direct-debit-step3__heading">
                    <FormattedText value="accountDirectDebitStep3-heading"/>
                </h2>
                <FormattedText value="accountDirectDebitStep3-subHeading" className="account-direct-debit-step3__paragraph"/>

                <div className="account-direct-debit-step3__intructions">
                    <p className="account-direct-debit-step3__intruction">
                        <FormattedText value="accountDirectDebitStep3-maximumFilesText"/>
                        <span className="account-direct-debit-step3__intruction-value">{FILE_NUMBER_LIMIT}</span>
                    </p>
                    <p className="account-direct-debit-step3__intruction">
                        <FormattedText value="accountDirectDebitStep3-maximumSizeText"/>
                        <span className="account-direct-debit-step3__intruction-value">{FILE_SIZE_LIMIT/1000}MB</span>
                    </p>
                    <p className="account-direct-debit-step3__intruction">
                        <FormattedText value="accountDirectDebitStep3-fileTypeText"/>
                        <span className="account-direct-debit-step3__intruction-value">{ALTERED_FILE_TYPES.map((element) => element.toUpperCase()).join(', ')}.</span>
                    </p>
                </div>
                <section className="account-direct-debit-step3__file-upload-section">
                    <h3 className="account-direct-debit-step3__upload-heading">
                        <FormattedText value="accountDirectDebitStep3-fileAttachedSectionHeading"/>
                    </h3>
                    {uploadHeadings}
                    <UploadedDocumentRow
                        filesAttached={filesAttached}
                        removeFile={removeFile}
                        setDescription={setDescription}
                        uploadDocumentLabel="accountDirectDebitStep3-uploadLabel"
                    />
                </section>
                {this.createUpload()}
                <ContractDisclaimerPersonalInfo
                    linkTextKey="accountDirectDebitLinkText"
                    linkUrlKey="accountDirectDebitLinkUrl"
                    messageKey="accountDirectDebitMsg"
                />
            </div>
        );
    }
}

AccountDirectDebitStep3.propTypes = {
    addFile: PropTypes.func.isRequired,
    immStep: PropTypes.object.isRequired,
    removeFile: PropTypes.func.isRequired,
    setDescription: PropTypes.func.isRequired,
}
module.exports = AccountDirectDebitStep3;
